<template>
  <section v-if="$role.restricAccess($route.name, 'view')">
    <breadcrumb-template
      :headtitle="$route.meta.title"
      :breadcrumbcurrent="$route.meta.title"
    ></breadcrumb-template>
    <v-card class="card-outline force-remove-box">
      <v-card-text class="force-custom-bg">
        <v-container fluid>
          <v-row dense class="mb-5 text-center text-md-left subtitle-1">
            <v-col cols="12" lg="4">
              <strong
                >Total payout:
                <v-avatar :size="$gold_coin_sm"
                  ><img :src="$goldCoinWhite" alt="coin"
                /></v-avatar>
                {{ dt_total_winnerprize | toNumberWithDecimal }}</strong
              >
            </v-col>
          </v-row>
          <v-row dense class="d-flex justify-end mt-n2">
            <v-col cols="12" md="6" lg="5" xl="2"></v-col>
            <!-- <v-col cols="12" md="6" lg="5" xl="2"></v-col> -->

            <v-col cols="12" lg="3" class="span-label" :class="($hideifuserisSupervisor())">
              <!-- <span v-html="setManagerSupervisorName()"></span> -->
              <span>{{ $agentName }}</span>
              <agent-credit-autocomplete-template
                ref="agent_autocomplete"
              ></agent-credit-autocomplete-template>
            </v-col>

            <!-- <v-col cols="12" lg="2" class="span-label">
              <span>Player</span>
              <player-autocomplete-template
                ref="player_autocomplete"
                filtertype="bethistory"
              ></player-autocomplete-template>
            </v-col> -->

            <v-col cols="12" lg="2" class="span-label">
              <span>Player</span>
              <v-combobox
                class="regular-field"
                dense
                clearable
                :items="playerlist"
                item-value="id"
                item-text="username"
                label="Player"
                v-model="filter.player_id"
              >
              </v-combobox>
            </v-col>

            <!-- <v-col cols="12" lg="2" class="span-label">
              <span>Player type</span>
              <v-select
                class="regular-field"
                dense
                clearable
                :items="['GM winners', 'App winners']"
                label="Payout type"
                v-model="filter.payouttype"
              ></v-select>
            </v-col> -->

            <v-col cols="12" lg="2" class="span-label">
              <span>Status</span>
              <v-select
                class="regular-field"
                dense
                clearable
                :items="['Claimed', 'Unclaimed']"
                label="Status"
                v-model="filter.status"
              ></v-select>
            </v-col>

            <v-col cols="12" lg="2" class="span-label">
              <span>Draw</span>
              <v-combobox
                class="regular-field"
                dense
                clearable
                :items="drawlist"
                item-value="id"
                item-text="name"
                label="Draw"
                v-model="filter.draw"
                multiple
              >
                <template v-slot:selection="{ item, index }">
                  <v-chip v-if="index === 0" small>
                    <span>{{ item.name }}</span>
                  </v-chip>
                  <span v-if="index === 1" class="grey--text text-caption"
                    >(+{{ filter.draw.length - 1 }})</span
                  >
                </template>
              </v-combobox>
            </v-col>
            <!-- <v-col cols="12" lg="2" class="span-label">
              <span>Region</span>
              <v-combobox
                class="regular-field"
                dense
                clearable
                :items="region_list"
                item-value="id"
                item-text="region_name"
                label="Region"
                v-model="filter.region_id"
              >
              </v-combobox>
            </v-col> -->
            <!-- <v-col cols="12" lg="2" class="span-label">
              <span>Area</span>
              <v-combobox
                class="regular-field"
                dense
                clearable
                :items="arealist"
                item-value="id"
                item-text="name"
                label="Area"
                v-model="filter.zone_id"
              >
              </v-combobox>
            </v-col> -->
            <v-col cols="12" lg="3" class="span-label">
              <span class="control-label">Dates</span>
              <v-dialog
                ref="dialog"
                v-model="filter_datedialog"
                :return-value.sync="filter.daterange"
                persistent
                width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    class="regular-field remove-alignment-clear-icon date-field"
                    dense
                    hide-details
                    v-model="filter.daterange"
                    label="Dates"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    clearable
                  ></v-text-field>
                </template>
                <v-date-picker v-model="filter.daterange" scrollable range>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="filter_datedialog = false"
                    >Cancel</v-btn
                  >
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.dialog.save(filter.daterange)"
                    >OK</v-btn
                  >
                </v-date-picker>
              </v-dialog>
            </v-col>

            <v-col cols="12" lg="3">
              <v-text-field
                clearable
                dense
                class="regular-field"
                v-model="dt_searchQuery"
                label="Search any keyword"
                hide-details
              ></v-text-field>
            </v-col>

            <v-col cols="12" lg="2" class="mt-7" style="padding-top:5px;">
              <v-btn
                color="green_button"
                class="float-right btn-block"
                @click="getDataFromApi()"
                >Search</v-btn
              >
            </v-col>

            <v-col cols="12" class="mt-2">
              <v-data-table
                class="custom-header-color table-bordered table-striped"
                :headers="dt_headers"
                :items="dt_resultlist"
                item-key="id"
                :loading="dt_loading"
                :options.sync="dt_options"
                :server-items-length="dt_totalResult"
              >
                <template v-slot:[`item.bet`]="{ item }"
                  ><v-avatar :size="$gold_coin_sm"
                    ><img :src="$goldCoinWhite" alt="coin"
                  /></v-avatar>
                  {{
                    item.bet == null ? 0.0 : item.bet | toNumberWithDecimal
                  }}</template
                >
                <template v-slot:[`item.datedraw`]="{ item }">
                  {{ item.datedraw | datetime }}</template
                >
                <template v-slot:[`item.user_type`]="{ item }">
                  {{ item.user_type ? "App" : "GM" }}</template
                >

                <template v-slot:[`item.winningprize`]="{ item }"
                  ><v-avatar :size="$gold_coin_sm"
                    ><img :src="$goldCoinWhite" alt="coin"
                  /></v-avatar>
                  {{
                    item.winningprize == null
                      ? 0.0
                      : item.winningprize | toNumberWithDecimal
                  }}</template
                >

                <template v-slot:[`item.claimed`]="{ item }">
                  <!-- <div v-if="item.claimed == 'Unclaimed'"> -->
                  <v-btn-toggle
                    block
                    rounded
                    v-if="item.claimed == 'Unclaimed'"
                  >
                    <v-btn
                      color="red_button"
                      dark
                      small
                      :loading="isLoadingBtn"
                      @click="claim(item)"
                      >{{ item.claimed }}</v-btn
                    >
                  </v-btn-toggle>
                  <div v-else>
                  <v-badge
                    color="green"
                    :content="item.claimed"
                    inline
                  ></v-badge>
                  </div>
                  <!-- </div> -->
                </template>

                <template
                  v-slot:[`item.actions`]
                  v-if="$role.restricAccess($route.name, 'edit')"
                >
                  <v-btn-toggle block rounded>
                    <v-btn color="green_button" dark small
                      ><v-icon>mdi-pencil</v-icon></v-btn
                    >
                    <v-btn color="red_button" dark small
                      ><v-icon>mdi-delete</v-icon></v-btn
                    >
                  </v-btn-toggle>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>

    <confirm-dialog ref="confirm"></confirm-dialog>
  </section>
</template>

<script>
export default {
  data() {
    return {
      dialogForm: false,
      isLoadingBtn: false,
      isLoadingBtnDelete: false,
      formerror: {},
      modalUpdate: false,
      dt_headers: [
        {
          text: this.$agentName,
          value: "agent",
          name: "agent",
        },
        {
          text: "Parent",
          value: "parent",
          name: "parent",
        },
        {
          text: "Player",
          value: "player_username",
          name: "player_username",
        },
        // {
        //   text: "Type",
        //   value: "user_type",
        //   name: "user_type",
        // },
        {
          text: "Contact #",
          value: "contact_no",
          name: "contact_no",
        },
        {
          text: "Reference #",
          value: "referenceno",
          name: "referenceno",
        },
        {
          text: "Draw",
          value: "draw_name",
          name: "draw_name",
        },
        // {
        //   text: "Area",
        //   value: "area_name",
        //   name: "area_name",
        // },
        {
          text: "Combination",
          value: "combination",
          name: "combination",
        },
        {
          text: "Bet amount",
          value: "bet",
          name: "bet",
        },
        {
          text: "Payout",
          value: "winningprize",
          name: "winningprize",
        },
        {
          text: "Date/time",
          value: "datedraw",
          name: "datedraw",
        },
        {
          text: "Status",
          value: "claimed",
          name: "claimed",
        },
      ],
      dt_options: {},
      dt_columns: {},
      dt_totalResult: 0,
      dt_searchInput: "",
      dt_searchQuery: "",
      dt_resultlist: [],
      dt_loading: true,
      dt_itemsPerPage: 50,
      dt_reload: "",
      dt_total_winnerprize: "",
      form: new this.$Form({
        id: "",
        name: "",
        username: "",
        email: "",
        password: "",
        roles: {},
        user_status: 1,
      }),
      agentID: new this.$Form({
        agent_id:
          this.$store.state.currentUser.agent_data.level != 0
            ? this.$store.state.currentUser.agent_data.id
            : null,
      }),
      region_list: [],
      arealist: [],
      filter: {
        datefrom: null,
        player_id: null,
        dateto: null,
        draw: [],
        daterange: [
          this.$moment().format("YYYY-MM-DD"),
          this.$moment().format("YYYY-MM-DD"),
        ],
        status: null,
        payouttype: null,
        region_id: null,
        zone_id: null,
        agent_id:
          this.$store.state.currentUser.agent_data.level != 0
            ? this.$store.state.currentUser.agent_data.id
            : null,
      },
      drawlist: [],
      playerlist: [],
      filter_datedialog: null,
    };
  },
  methods: {
    setManagerSupervisorName() {
      if (this.$store.state.currentUser.agent_data.level == 0) {
        return "Manager";
      } else if (this.$store.state.currentUser.agent_data.level == 1) {
        return "Supervisor";
      } else if (this.$store.state.currentUser.agent_data.level == 2) {
        return "Supervisor";
      } else {
        return "Manager";
      }
    },
    async claim(data) {
      if (await this.$refs.confirm.open("Confirm", "Want to claim this?")) {
        if (this.isLoadingBtn) return;
        this.isLoadingBtn = true;

        this.$axios
          .put(this.$_CONFIG.api("API_WINNERS") + "/" + data.id)
          .then((data) => {
            this.isLoadingBtn = false;
            this.getDataFromApi();
          })
          .catch((error) => {
            this.isLoadingBtn = false;
            this.$toast.fire({ icon: "error", title: "Something went wrong!" });
          });
      }
    },
    paramsfilter() {
      let from, to;

      if (this.filter.daterange) {
        from = this.$moment(this.filter.daterange[0]).format("YYYY-MM-DD");
        to = this.$moment(this.filter.daterange[1]).format("YYYY-MM-DD");
      }
      let subagent =
        this.$store.state.currentUser.agent_data.level != 0
          ? this.$store.state.currentUser.agent_data.id
          : null;
      try {
        if (this.$refs.agent_autocomplete.autocomplete_model.id) {
          subagent = this.$refs.agent_autocomplete.autocomplete_model.id;
        }
      } catch (error) {
        subagent =
          this.$store.state.currentUser.agent_data.level != 0
            ? this.$store.state.currentUser.agent_data.id
            : null;
      }

      let player = null;
      try {
        if (this.filter.player_id) {
          player = this.filter.player_id["id"];
        }
      } catch (error) {
        player = null;
      }

      return {
        ...this.dt_options,
        searchdata: this.dt_searchQuery,
        date: this.filter.date,
        reload: this.dt_reload,
        status: this.filter.status,
        draws: this.filter.draw.join(","),
        filterDateFrom: from,
        filterDateTo: to,
        payouttype: this.filter.payouttype,
        filter_agent_id: subagent,
        player_id: player,
        region_id: this.filter.region_id,
        zone_id: this.filter.zone_id,
        agent_id: subagent,
      };
    },
    async getDataFromApi() {
      this.dt_loading = true;
      var paramsfilter = await this.paramsfilter();
      this.dt_columns = await this.$YajraDT.setHeader(this.dt_headers);
      let params = await this.$YajraDT.params(
        paramsfilter,
        this.dt_options,
        this.dt_itemsPerPage,
        this.dt_columns
      );
      let apiPath = (await this.$_CONFIG.api()) + "/winnerslist";

      await this.$axios
        .post(apiPath + "?" + this.$.param(params))
        .then((res) => {
          if (this.dt_totalResult != res.data.recordsFiltered) {
            this.dt_options.page = 1;
          }

          this.dt_resultlist = res.data.data;
          this.dt_totalResult = res.data.recordsFiltered;
          this.dt_total_winnerprize = res.data.totalsales;
          this.dt_loading = false;
        })
        .catch((err) => {
          this.dt_loading = false;
          console.log("Error searching");
        });

      var unwatch = this.$watch(
        "dt_options.page",
        function(newValue, oldValue) {
          this.getDataFromApi();
          unwatch();
        },
        { deep: true }
      );
    },
    getdrawlist() {
      this.$axios
        .get(this.$_CONFIG.api("API_DRAW_DROPDOWN"))
        .then((res) => {
          this.drawlist = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async regionlist() {
      let response = await this.$axios.get(
        this.$_CONFIG.api() + "/allregionlist"
      );
      this.region_list = response.data;
    },
    getarealist() {
      this.$axios
        .get(this.$_CONFIG.api() + "/allzonelist")
        .then((res) => {
          this.arealist = res.data;
          console.log(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getplayerlist() {
      this.agentID
        .post(this.$_CONFIG.api() + "/v1/playerlist")
        .then((res) => {
          this.playerlist = res.data;
          console.log(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  created() {
    this.getdrawlist();
    this.getDataFromApi();
    this.regionlist();
    this.getarealist();
    this.getplayerlist();
  },
  mounted() {},
};
</script>
<style scoped></style>